import { useEffect, useState } from 'react'
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
  ZoomableGroup,
} from 'react-simple-maps'
import ReactTooltip from 'react-tooltip'
import { getClient } from '@lib/sanity'

// Different world views available
// https://www.naturalearthdata.com/blog/admin-0-countries-point-of-views/
const geoUrl = '/maps/ne_10m_admin_0_countries_gbr.json'

const MemberMap = ({ items, country, setCountry }) => {
  const [tooltip, setTooltip] = useState('')
  const [members, setMembers] = useState(items)

  useEffect(() => {
    if (!items && !members) {
      getClient(false)
        .fetch(`*[_type == "member"] | order(lower(name) asc){_id, country}`)
        .then((data) => setMembers(data))
        .catch(console.error)
    }
  }, [items, members, setMembers])

  if (!members) {
    return null
  }
  return (
    <div className="mb-4">
      <p className="text-center">
        Click on the map to find out more about our membership
      </p>
      <ComposableMap
        data-tip=""
        projectionConfig={{
          rotate: [-10, 0, 0],
          scale: 147,
        }}
      >
        <ZoomableGroup zoom={1}>
          <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
          <Graticule stroke="#E4E5E6" strokeWidth={0.5} />
          {members.length > 0 && (
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const d = members.filter(
                    (s) => s.country === geo.properties.ISO_A2
                  )
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        country === geo.properties.ISO_A2
                          ? `#015B9B`
                          : d.length
                          ? '#ef8782'
                          : '#fce7e6'
                      }
                      style={{
                        default: { outline: 'none' },
                        hover: { outline: 'none' },
                        pressed: { outline: 'none' },
                      }}
                      onMouseEnter={() => {
                        if (d.length) {
                          const { NAME } = geo.properties
                          setTooltip(`${NAME} - ${d.length}`)
                        }
                      }}
                      onMouseLeave={() => {
                        setTooltip('')
                      }}
                      onClick={() => {
                        if (d.length) {
                          if (country === geo.properties.ISO_A2) {
                            setCountry(null)
                          } else {
                            setCountry(geo.properties.ISO_A2)
                          }
                        }
                      }}
                    />
                  )
                })
              }
            </Geographies>
          )}
        </ZoomableGroup>
      </ComposableMap>
      <ReactTooltip backgroundColor="#015B9B">{tooltip}</ReactTooltip>
    </div>
  )
}
export default MemberMap
